import { Demographics } from "../../../data-model/medicalPaOrdersModel";

/**
 * Extracts and formats a patient's full name from any order shape that
 * carries a `demographics` block (Firestore `MedicalPaOrder` or the Postgres
 * `GeneralOrderDetails`).
 *
 * @param data - Object exposing an optional `demographics` block
 * @returns Space-joined "first last" name, trimmed of missing parts
 */
export const getPatientName = (data: {
  demographics?: Demographics;
}): string => {
  return `${data?.demographics?.first_name ?? ""} ${data?.demographics?.last_name ?? ""}`.trim();
};

/**
 * Converts a Blob to a File object
 * @param blob - The blob to convert
 * @param fileName - The desired file name
 * @returns File object
 */
export const blobToFile = (blob: Blob, fileName: string): File => {
  return new File([blob], fileName, { type: blob.type });
};
